import { useState } from "react";
import { PieChart, Pie, Cell } from "recharts";
import { UtilizationData } from "../../../utils/types";
import { ContactUsForm } from "../../ContactUsForm";

export const UtilizationCard = ({
  data,
}: {
  data?: UtilizationData;
}) => {
  const [isContactUsModalOpen, setIsContactUsModalOpen] = useState(false);
  const { used = 0, total = 0, title = "-", description = "-", ctaText } =
    data || {};
  const isUtilizationAvailable = total > 0;
  const percentage = isUtilizationAvailable ? Math.round((used / total) * 100) : "-";

  const chartData = [
    { name: "Unused", value: isUtilizationAvailable ? Math.max(total - used, 0) : 1 },
    { name: "Used", value: isUtilizationAvailable ? used : 0 },
  ];

  const COLORS = ["#E5E7EB", "#FACC15"];

  const handleOpenContactUsForm = () => {
    setIsContactUsModalOpen(true);
  };

  const handleCloseContactUsForm = () => {
    setIsContactUsModalOpen(false);
  };

  return (
    <div className="flex items-center gap-3 bg-card-yellow-bg dark:bg-card-yellow-bg-dk rounded-lg border border-card-yellow-stroke dark:border-card-yellow-stroke-dk p-3 col-span-2">
      <div className="relative shrink-0 w-[54px] h-[54px]">
        <PieChart width={54} height={54}>
          <Pie
            data={chartData}
            cx={24}
            cy={24}
            innerRadius={0}
            outerRadius={24}
            dataKey="value"
            startAngle={90}
            endAngle={450}
            stroke="none"
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index]} />
            ))}
          </Pie>
        </PieChart>
      </div>
      <div>
        <div className="flex items-center gap-x-2">
          <div className="text-2xl text-verba-indigo dark:text-verba-indigo-dk">
            {isUtilizationAvailable ? `${percentage}%` : "-"}
          </div>
          <div className="w-px h-3 bg-card-yellow-stroke dark:bg-card-yellow-stroke-dk" />
          <div className="text-xs font-medium text-data dark:text-data-dk">
            {title}
          </div>
        </div>
        <div className="text-xs text-data dark:text-data-dk mt-1">
          {description}{" "}
          {ctaText && (
            <button
              type="button"
              className="text-verba-blue dark:text-verba-blue-dk font-semibold hover:underline"
              onClick={handleOpenContactUsForm}
            >
              {ctaText}
            </button>
          )}
        </div>
      </div>
      <ContactUsForm
        open={isContactUsModalOpen}
        onClose={handleCloseContactUsForm}
      />
    </div>
  );
};
